// extracted by css-extract-rspack-plugin
export default {"Content":"Content-module__Content__mHmep"};